export default "/build/static/fonts/Whitney-Semibld_Web.woff";